import type { ResponsiveVariant } from '@/styled-system/css';

/**
 * Expands a static boolean variant (e.g. `reverse` or `conjoined`) so it shares
 * the same breakpoints as a responsive `orientation`.
 *
 * Compound variants only match when every key (e.g. `reverse_lg`,
 * `conjoined_lg`) is present in the resolved props, so a static boolean
 * alongside a responsive orientation must be broadcast across each of
 * orientation's breakpoints. Already-responsive values pass through unchanged.
 */
export function normalizeResponsiveStyles(
  value: ResponsiveVariant<boolean>,
  orientation: ResponsiveVariant<'horizontal' | 'vertical'>,
): ResponsiveVariant<boolean> {
  if (typeof value !== 'boolean') {
    return value;
  }

  if (orientation && typeof orientation === 'object') {
    const responsiveValue = {} as Record<string, boolean>;
    for (const breakpoint of Object.keys(orientation)) {
      responsiveValue[breakpoint] = value;
    }

    return responsiveValue as ResponsiveVariant<boolean>;
  }

  return value;
}
